(function () {
  var TRADE_GROUPS = [
    {
      queries: ['auto', 'automotive', 'mechanic', 'garage', 'mot', 'vehicle', 'vehicles', 'car', 'cars', 'motor', 'motorsport', 'drift', 'racing', 'racer', 'campervan', 'camper', 'tyre', 'tire'],
      handles: [
        'tyre-nfc-keychain',
        'wrench-nfc-keychain',
        'campervan-nfc-keychain',
        'race-car-nfc-keychain',
        'driving-school-nfc-keychain',
        'traffic-cone-nfc-keychain',
        'blue-beast-nfc-keychain',
        'classic-corner-king-nfc-keychain',
      ],
      tokens: ['tyre', 'tire', 'wrench', 'campervan', 'camper', 'van', 'race', 'drift', 'driving', 'automotive'],
    },
    {
      queries: ['custom', 'personalised', 'personalized', 'personalise', 'personalize', 'bespoke', 'logo', 'engraved', 'your logo', 'my logo', 'my brand', 'own design', 'custom logo'],
      handles: ['custom-nfc-keychain'],
      tokens: ['custom', 'logo', 'bespoke', 'brand'],
      exclusive: true,
    },
    {
      queries: ['salon', 'hairdresser', 'hair stylist', 'hairstylist', 'hair', 'blow dry', 'hairdresser'],
      handles: ['pink-hair-dryer-nfc-keychain', 'barber-pole-nfc-keychain'],
      tokens: ['hair', 'dryer', 'salon'],
    },
    {
      queries: ['barber', 'barbershop', 'fade'],
      handles: ['barber-pole-nfc-keychain'],
      tokens: ['barber', 'pole'],
    },
    {
      queries: ['nails', 'nail', 'manicure', 'pedicure'],
      handles: ['pink-nail-polish-nfc-keychain'],
      tokens: ['nail', 'polish'],
    },
    {
      queries: [
        'beauty',
        'hair and beauty',
        'hair beauty',
        'beautician',
        'beauty salon',
        'spa',
        'lashes',
        'lash',
        'eyelash',
        'eyelashes',
        'lash tech',
        'perfume',
        'fragrance',
      ],
      handles: [
        'pink-hair-dryer-nfc-keychain',
        'pink-nail-polish-nfc-keychain',
        'eyelash-nfc-keychain',
        'perfume-nfc-keychain',
        'lipstick-nfc-keychain',
        'syringe-nfc-keychain',
        'laser-hair-removal-machine-nfc-keychain',
        'laser-pmu-nfc-keychain',
      ],
      tokens: ['hair', 'beauty', 'lash', 'perfume', 'nail', 'syringe', 'laser'],
      exclusive: true,
    },
    {
      queries: ['aesthetics', 'aesthetic', 'aesthetic clinic', 'aesthetics clinic', 'pmu', 'botox', 'filler', 'fillers', 'laser', 'lip filler', 'makeup'],
      handles: [
        'syringe-nfc-keychain',
        'bolt-nfc-keychain',
        'lips-nfc-keychain',
        'lipstick-nfc-keychain',
        'laser-hair-removal-machine-nfc-keychain',
        'laser-pmu-nfc-keychain',
        'pmu-nfc-keychain',
      ],
      tokens: ['syringe', 'bolt', 'laser', 'pmu', 'aesthetic', 'botox'],
    },
    {
      queries: ['medical', 'doctor', 'clinic', 'pharmacy', 'nurse', 'dentist', 'gp', 'health', 'hospital', 'optician', 'dentist', 'surgery'],
      handles: ['stethoscope-nfc-keychain', 'brain-nfc-keychain', 'tooth-nfc-keychain', 'eye-test-nfc-keychain'],
      tokens: ['stethoscope', 'medical', 'tooth', 'brain'],
    },
    {
      queries: ['pets', 'pet', 'dog', 'groomer', 'vet', 'puppy', 'dog walker', 'kennel', 'dog groomer'],
      handles: ['dog-groomer-nfc-keychain', 'dog-nfc-keychain', 'pink-paw-nfc-keychain', 'vet-nfc-keychain', 'balloon-dog-nfc-keychain'],
      tokens: ['dog', 'pet', 'groomer', 'vet', 'paw'],
    },
    {
      queries: ['cafe', 'coffee', 'coffee shop', 'barista', 'espresso', 'coffee house'],
      handles: ['coffee-nfc-keychain', 'beverage-nfc-keychain'],
      tokens: ['coffee', 'cafe'],
    },
    {
      queries: ['food', 'restaurant', 'chef', 'kitchen', 'bakery', 'sushi', 'pizza', 'catering', 'takeaway', 'dessert', 'ice cream', 'cookie', 'breakfast'],
      handles: [
        'cookie-nfc-keychain',
        'salmon-nigiri-nfc-keychain',
        'pizza-slice-nfc-keychain',
        'chef-hat-nfc-keychain',
        'food-truck-nfc-keychain',
        'english-breakfast-nfc-keychain',
        'sweet-nfc-keychain',
        'pink-cupcake-nfc-keychain',
        'pink-milkshake-nfc-keychain',
        'pink-ice-cream-nfc-keychain',
        'beverage-nfc-keychain',
        'wine-glass-nfc-keychain',
      ],
      tokens: ['food', 'cookie', 'sushi', 'nigiri', 'pizza', 'chef', 'cupcake', 'bakery'],
    },
    {
      queries: ['music', 'musician', 'dj', 'band', 'gig', 'concert', 'violin', 'saxophone', 'studio', 'jazz', 'orchestra', 'singer'],
      handles: [
        'violin-nfc-keychain',
        'saxophone-nfc-keychain',
        'microphone-nfc-keychain',
        'vinyl-nfc-keychain',
        'headphones-nfc-keychain',
      ],
      tokens: ['music', 'violin', 'saxophone', 'microphone', 'vinyl', 'headphones'],
    },
    {
      queries: ['gym', 'fitness', 'sport', 'football', 'personal trainer', 'trainer', 'football club'],
      handles: ['football-nfc-keychain', 'sneaker-nfc-keychain'],
      tokens: ['football', 'gym', 'sneaker'],
    },
    {
      queries: ['cleaning', 'cleaner', 'cleaners', 'bins', 'bin', 'wheelie', 'wheelie bin', 'rubbish', 'waste', 'refuse', 'housekeeping'],
      handles: ['wheelie-bin-nfc-keychain', 'cleaning-spray-nfc-keychain'],
      tokens: ['bin', 'wheelie', 'cleaning', 'spray', 'rubbish', 'waste'],
    },
    {
      queries: ['garden', 'gardener', 'landscaper', 'lawn', 'trees'],
      handles: ['tree-nfc-keychain', 'lawnmower-nfc-keychain', 'toadstool-nfc-keychain'],
      tokens: ['tree', 'lawn', 'garden'],
    },
    {
      queries: [
        'trades',
        'trade',
        'tradesperson',
        'tradesman',
        'handyman',
        'handy man',
        'diy',
        'tools',
        'toolbox',
      ],
      handles: [
        'wrench-nfc-keychain',
        'paint-brush-nfc-keychain',
        'chainsaw-nfc-keychain',
        'lawnmower-nfc-keychain',
        'handsaw-nfc-keychain',
        'bulb-nfc-keychain',
      ],
      tokens: ['wrench', 'spanner', 'paint', 'chainsaw', 'lawnmower', 'mower', 'handsaw'],
    },
    {
      queries: ['tattoo', 'tattoos', 'tattooist', 'tattooer', 'piercing', 'piercings', 'piercer', 'ear piercing', 'ink'],
      handles: ['tattoo-machine-nfc-keychain', 'piercing-nfc-keychain'],
      tokens: ['tattoo', 'piercing'],
    },
    {
      queries: ['florist', 'florists', 'flowers', 'flower', 'bouquet', 'floral'],
      handles: ['flower-bouquet-nfc-keychain'],
      tokens: ['florist', 'flower', 'bouquet'],
    },
    {
      queries: ['photography', 'photographer', 'photographers', 'photo', 'photos', 'camera', 'cameras'],
      handles: ['camera-nfc-keychain'],
      tokens: ['camera', 'photo', 'photography'],
    },
    {
      queries: ['events', 'party', 'planner', 'celebrations', 'balloon'],
      handles: ['balloon-nfc-keychain', 'balloon-dog-nfc-keychain', 'firework-nfc-keychain', 'face-paint-nfc-keychain', 'best-wishes-card-nfc-keychain'],
      tokens: ['balloon', 'firework', 'party', 'event'],
    },
    {
      queries: [
        'hotel',
        'hotels',
        'airbnb',
        'guest house',
        'guesthouse',
        'hospitality',
        'accommodation',
        'booking',
        'bookings',
        'book now',
        'book online',
        'book a room',
        'book a table',
        'book an appointment',
        'book appointment',
        'room to book',
        'room booking',
        'table booking',
        'hotel booking',
        'online booking',
        'make a booking',
        'booking link',
        'bookable',
        'reservation',
        'reservations',
        'reserve a table',
        'appointment',
        'appointments',
        'schedule',
        'availability',
        'check in',
        'reception',
        'bnb',
      ],
      handles: [
        'house-nfc-keychain',
        'wisetap-house-nfc-keychain',
        'key-nfc-keychain',
        'website-nfc-keychain',
        'custom-nfc-keychain',
      ],
      tokens: ['house', 'key', 'hotel', 'booking', 'website', 'custom'],
    },
    {
      queries: ['sewing', 'sew', 'sewn', 'fabric', 'fabrics', 'textile', 'textiles', 'tailor', 'tailoring', 'seamstress', 'dressmaker', 'alterations', 'embroidery', 'quilting', 'haberdashery'],
      handles: ['sewing-machine-nfc-keychain', 'yarn-ball-nfc-keychain'],
      tokens: ['sewing', 'fabric', 'tailor', 'yarn'],
    },
    {
      queries: ['needle', 'needles', 'needlework'],
      handles: ['syringe-nfc-keychain', 'yarn-ball-nfc-keychain', 'sewing-machine-nfc-keychain'],
      tokens: ['syringe', 'yarn', 'sewing'],
    },
    {
      queries: ['others', 'other', 'misc', 'miscellaneous'],
      handles: [],
      tokens: [],
      leftover: true,
    },
  ];

  var PRODUCT_KEYWORDS = {
    'custom-nfc-keychain': ['personalised', 'personalized', 'personalise', 'personalize', 'bespoke', 'engraved', 'your logo', 'my logo', 'own design', 'branded'],
    'campervan-nfc-keychain': ['auto', 'camper', 'van', 'motorhome', 'vehicle', 'automotive'],
    'race-car-nfc-keychain': ['auto', 'car', 'racing', 'motorsport', 'drift', 'vehicle'],
    'classic-corner-king-nfc-keychain': ['auto', 'car', 'drift', 'drift king', 'motorsport', 'racing', 'vehicle'],
    'blue-beast-nfc-keychain': ['auto', 'car', 'drift', 'motorsport', 'racing', 'vehicle'],
    'tyre-nfc-keychain': ['auto', 'tire', 'wheel', 'garage', 'mot', 'vehicle'],
    'wrench-nfc-keychain': ['auto', 'mechanic', 'garage', 'spanner', 'repair', 'vehicle', 'trades', 'plumber', 'plumbing', 'handyman', 'tools', 'toolbox', 'diy'],
    'driving-school-nfc-keychain': ['auto', 'instructor', 'lessons', 'vehicle'],
    'traffic-cone-nfc-keychain': ['auto', 'driving', 'road', 'vehicle'],
    'bolt-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'laser', 'plasma'],
    'lips-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'filler', 'lips'],
    'lipstick-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'makeup', 'lipstick'],
    'syringe-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'botox', 'filler', 'fillers', 'pmu', 'needle', 'needles'],
    'laser-hair-removal-machine-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'laser', 'permanent makeup'],
    'laser-pmu-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'laser', 'permanent makeup'],
    'pmu-nfc-keychain': ['aesthetic', 'aesthetics', 'clinic', 'pmu', 'laser', 'permanent makeup'],
    'food-truck-nfc-keychain': ['food', 'restaurant', 'street food', 'van'],
    'cookie-nfc-keychain': ['food', 'bakery', 'dessert', 'cafe'],
    'salmon-nigiri-nfc-keychain': ['food', 'sushi', 'japanese', 'restaurant', 'nigiri'],
    'pizza-slice-nfc-keychain': ['food', 'restaurant', 'pizzeria'],
    'chef-hat-nfc-keychain': ['food', 'restaurant', 'chef', 'kitchen'],
    'english-breakfast-nfc-keychain': ['food', 'cafe', 'restaurant', 'breakfast'],
    'sweet-nfc-keychain': ['food', 'bakery', 'dessert', 'candy'],
    'pink-cupcake-nfc-keychain': ['food', 'bakery', 'dessert'],
    'pink-milkshake-nfc-keychain': ['food', 'cafe', 'dessert'],
    'pink-ice-cream-nfc-keychain': ['food', 'dessert', 'cafe'],
    'wine-glass-nfc-keychain': ['food', 'restaurant', 'wine', 'bar'],
    'violin-nfc-keychain': ['music', 'musician', 'orchestra', 'strings'],
    'saxophone-nfc-keychain': ['music', 'musician', 'jazz', 'band'],
    'microphone-nfc-keychain': ['music', 'musician', 'dj', 'singer', 'podcast'],
    'vinyl-nfc-keychain': ['music', 'dj', 'record', 'studio'],
    'headphones-nfc-keychain': ['music', 'dj', 'studio', 'producer'],
    'best-wishes-card-nfc-keychain': ['greeting', 'card', 'gift', 'wishes', 'events', 'party'],
    'wheelie-bin-nfc-keychain': ['cleaning', 'cleaner', 'bin', 'bins', 'wheelie', 'rubbish', 'waste', 'refuse'],
    'cleaning-spray-nfc-keychain': ['cleaning', 'cleaner', 'housekeeping', 'spray', 'bins'],
    'house-nfc-keychain': ['estate agent', 'landlord', 'property', 'builder', 'trades', 'hotel', 'airbnb', 'booking', 'hospitality', 'accommodation'],
    'wisetap-house-nfc-keychain': ['estate agent', 'landlord', 'property', 'builder', 'trades', 'hotel', 'airbnb', 'booking', 'hospitality', 'accommodation'],
    'tree-nfc-keychain': ['garden', 'gardener', 'landscaper', 'arborist'],
    'lawnmower-nfc-keychain': ['garden', 'gardener', 'gardening', 'lawn', 'lawn mower', 'mower', 'grass', 'landscaper', 'landscaping', 'groundskeeper', 'trades'],
    'flower-bouquet-nfc-keychain': ['florist', 'florists', 'flowers', 'flower', 'bouquet', 'floral', 'garden', 'events'],
    'bulb-nfc-keychain': ['electrician', 'electric', 'electrical', 'trades', 'lighting', 'handyman'],
    'paint-brush-nfc-keychain': ['painter', 'decorator', 'decorating', 'paint', 'paintbrush', 'paint brush', 'trades', 'handyman', 'diy'],
    'handsaw-nfc-keychain': ['carpenter', 'joinery', 'joiner', 'builder', 'trades', 'handyman', 'saw'],
    'chainsaw-nfc-keychain': ['landscaper', 'landscaping', 'tree surgeon', 'arborist', 'forestry', 'chainsaw', 'chain saw', 'trades', 'garden', 'gardener'],
    'key-nfc-keychain': ['locksmith', 'estate agent', 'keys', 'hotel', 'airbnb', 'booking', 'room', 'hospitality'],
    'tattoo-machine-nfc-keychain': ['tattoo', 'tattoos', 'tattooist', 'ink'],
    'piercing-nfc-keychain': ['piercing', 'piercings', 'piercer', 'ear piercing', 'tattoo'],
    'camera-nfc-keychain': ['photography', 'photographer', 'photo', 'photos', 'camera', 'studio'],
    'sewing-machine-nfc-keychain': ['tailor', 'fashion', 'seamstress', 'clothing', 'sewing', 'sew', 'fabric', 'fabrics', 'textile', 'embroidery', 'alterations', 'dressmaker', 'haberdashery', 'needle', 'needles'],
    'yarn-ball-nfc-keychain': ['yarn', 'knitting', 'fabric', 'textile', 'crafts', 'needle', 'needles'],
    'website-nfc-keychain': ['website', 'web', 'digital', 'linktree', 'booking', 'book online', 'appointment'],
    'eyelash-nfc-keychain': ['lashes', 'lash', 'eyelash', 'eyelashes', 'lash tech', 'beauty', 'salon'],
    'perfume-nfc-keychain': ['perfume', 'fragrance', 'beauty', 'salon', 'spa'],
    'pink-hair-dryer-nfc-keychain': ['salon', 'hair', 'hairdresser', 'beauty', 'blow dry'],
    'pink-nail-polish-nfc-keychain': ['nails', 'nail', 'manicure', 'beauty', 'salon'],
  };

  var finders = [];
  var catalogPromise = null;

  function foldSpelling(value) {
    return String(value || '')
      .replace(/isation/g, 'ization')
      .replace(/ised/g, 'ized')
      .replace(/ises/g, 'izes')
      .replace(/ise\b/g, 'ize')
      .replace(/colour/g, 'color')
      .replace(/tyre/g, 'tire');
  }

  function stem(word) {
    var w = foldSpelling(word);
    if (w.length > 7 && /ization$/.test(w)) return w.slice(0, -7);
    if (w.length > 6 && /ized$/.test(w)) return w.slice(0, -4);
    if (w.length > 5 && /ing$/.test(w)) return w.replace(/ing$/, '');
    if (w.length > 4 && /s$/.test(w) && !/ss$|us$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function normalize(value) {
    return foldSpelling(
      String(value || '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/nfc|keychain|wisetap|\|/g, ' ')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    );
  }

  function tokens(value) {
    return normalize(value).split(' ').filter(function (part) {
      return part.length > 1;
    });
  }

  function unique(list) {
    var seen = {};
    return list.filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    if (Math.abs(a.length - b.length) > 2) return 3;

    var prev = new Array(b.length + 1);
    var next = new Array(b.length + 1);
    var i;
    var j;

    for (j = 0; j <= b.length; j += 1) prev[j] = j;

    for (i = 1; i <= a.length; i += 1) {
      next[0] = i;
      for (j = 1; j <= b.length; j += 1) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        next[j] = Math.min(next[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      var swap = prev;
      prev = next;
      next = swap;
    }

    return prev[b.length];
  }

  function moneyToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') {
      return value > 999 ? Math.round(value) : Math.round(value * 100);
    }
    var parsed = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (Number.isNaN(parsed)) return 0;
    return Math.round(parsed * 100);
  }

  function formatMoney(cents, format) {
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    return String(format || '£{{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function imageUrl(src) {
    if (!src) return '';
    if (src.indexOf('width=') !== -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=720';
  }

  function normalizeProduct(raw, fromAjax) {
    if (!raw) return null;

    var tags = raw.tags;
    if (typeof tags === 'string') {
      tags = tags.split(',').map(function (tag) {
        return tag.trim();
      });
    }

    var variant = fromAjax && raw.variants && raw.variants[0] ? raw.variants[0] : null;
    var price = fromAjax ? moneyToCents(variant && variant.price) : Number(raw.price) || 0;
    var compareAt = fromAjax
      ? moneyToCents(variant && variant.compare_at_price)
      : Number(raw.compareAt || raw.compare_at_price) || 0;
    var image = raw.image;
    if (fromAjax) {
      image = raw.images && raw.images[0] ? raw.images[0].src : '';
    }

    var title = raw.title || '';
    var handle = raw.handle || '';
    var type = raw.type || raw.product_type || '';
    var searchTags = (tags || []).filter(function (tag) {
      return !/^(instagram|facebook|google|tiktok|twitter|youtube|whatsapp|linkedin|snapchat)$/i.test(String(tag).trim());
    });
    var searchBits = [title, handle.replace(/-/g, ' '), type, searchTags.join(' ')];

    if (PRODUCT_KEYWORDS[handle]) {
      searchBits.push(PRODUCT_KEYWORDS[handle].join(' '));
    }

    TRADE_GROUPS.forEach(function (group) {
      if (group.handles.indexOf(handle) !== -1) {
        searchBits.push(group.queries.join(' '));
      }
    });

    var searchText = normalize(searchBits.join(' '));

    return {
      id: raw.id,
      title: title,
      handle: handle,
      url: raw.url || '/products/' + handle,
      tags: tags || [],
      type: type,
      price: price,
      compareAt: compareAt,
      available: fromAjax ? Boolean(variant && variant.available) : raw.available !== false,
      image: imageUrl(image),
      imageAlt: raw.imageAlt || title,
      searchText: searchText,
      words: unique(searchText.split(' ').filter(Boolean)),
    };
  }

  function mergeCatalog(existing, incoming) {
    var map = {};
    existing.concat(incoming).forEach(function (product) {
      if (product && product.id) map[product.id] = product;
    });
    return Object.keys(map).map(function (id) {
      return map[id];
    });
  }

  function readSeed(root) {
    var node = root.querySelector('[data-keychain-finder-seed]');
    if (!node) return [];
    try {
      return (JSON.parse(node.textContent) || []).map(function (item) {
        return normalizeProduct(item, false);
      }).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function fetchCatalog(url) {
    if (catalogPromise) return catalogPromise;
    if (!url) {
      catalogPromise = Promise.resolve([]);
      return catalogPromise;
    }

    catalogPromise = (async function () {
      var all = [];
      var page = 1;
      var limit = 250;

      while (page < 6) {
        var response = await fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'limit=' + limit + '&page=' + page, {
          credentials: 'same-origin',
        });
        if (!response.ok) break;
        var data = await response.json();
        var products = (data.products || []).map(function (item) {
          return normalizeProduct(item, true);
        }).filter(Boolean);
        all = all.concat(products);
        if (products.length < limit) break;
        page += 1;
      }

      return all;
    })().catch(function () {
      return [];
    });

    return catalogPromise;
  }

  function hitsLabel(queryNorm, label) {
    var labelNorm = normalize(label);
    if (!labelNorm) return false;
    if (queryNorm === labelNorm) return true;
    if (stem(queryNorm) === stem(labelNorm) && stem(queryNorm).length >= 4) return true;
    if (queryNorm.length >= 2 && labelNorm.indexOf(queryNorm) === 0) return true;
    if (labelNorm.length <= 3 || queryNorm.length <= 3) return false;
    return queryNorm.indexOf(labelNorm) !== -1 || labelNorm.indexOf(queryNorm) !== -1;
  }

  function expandQuery(query) {
    var queryNorm = normalize(query);
    var extra = [];
    var preferred = [];
    var exclusive = [];
    var otherMatched = false;

    if (queryNorm.length < 2) {
      return {
        tokens: unique(tokens(query).map(stem)),
        preferred: [],
        exclusive: [],
        leftover: false,
      };
    }

    var leftover = false;

    TRADE_GROUPS.forEach(function (group) {
      var matched = group.queries.some(function (label) {
        return hitsLabel(queryNorm, label);
      });
      if (!matched) return;
      if (group.leftover) {
        leftover = true;
        return;
      }
      extra = extra.concat(group.tokens);
      preferred = preferred.concat(group.handles);
      if (group.exclusive) {
        exclusive = exclusive.concat(group.handles);
      } else {
        otherMatched = true;
      }
    });

    return {
      tokens: unique(tokens(query).concat(tokens(query).map(stem), extra)),
      preferred: unique(preferred),
      exclusive: exclusive.length ? unique(exclusive) : [],
      leftover: leftover,
    };
  }

  function chipTaggedHandles(chips) {
    var tagged = {};
    var chipQueries = [];

    (chips || []).forEach(function (chip) {
      var query = normalize(chip.getAttribute('data-query') || '');
      if (!query || query === 'others' || query === 'other') return;
      chipQueries.push(query);
    });

    TRADE_GROUPS.forEach(function (group) {
      if (group.leftover) return;
      var isChip = group.queries.some(function (label) {
        var labelNorm = normalize(label);
        return chipQueries.some(function (query) {
          return query === labelNorm || hitsLabel(query, label);
        });
      });
      if (!isChip) return;
      group.handles.forEach(function (handle) {
        tagged[handle] = true;
      });
    });

    return tagged;
  }

  function scoreProduct(product, query, expanded) {
    var queryNorm = normalize(query);
    if (!queryNorm) return 0;

    var score = 0;
    var title = normalize(product.title);
    var productStems = product.words.map(stem);

    if (title === queryNorm) score += 160;
    else if (stem(title) === stem(queryNorm)) score += 150;
    if (title.indexOf(queryNorm) !== -1) score += 90;
    if (product.handle === queryNorm.replace(/\s/g, '-')) score += 80;
    if (expanded.preferred.indexOf(product.handle) !== -1) score += 70;

    expanded.tokens.forEach(function (token) {
      var tokenStem = stem(token);

      if (title.split(' ').indexOf(token) !== -1) {
        score += 36;
        return;
      }
      if (product.words.some(function (word) { return word === token || word === tokenStem; })) {
        score += 24;
        return;
      }
      if (productStems.indexOf(tokenStem) !== -1 && tokenStem.length >= 4) {
        score += 22;
        return;
      }
      if (token.length >= 4 && product.words.some(function (word) { return word.indexOf(token) === 0; })) {
        score += 18;
        return;
      }
      if (token.length >= 4 && product.searchText.indexOf(token) !== -1) {
        score += 12;
        return;
      }

      var best = 3;
      for (var i = 0; i < product.words.length; i += 1) {
        var word = product.words[i];
        if (Math.abs(word.length - token.length) > 2) continue;
        var distance = levenshtein(word, token);
        if (distance < best) best = distance;
        if (best === 0) break;
      }

      if (best === 1 && token.length >= 4) score += 14;
      else if (best === 2 && token.length >= 5) score += 7;
    });

    if (product.handle === 'custom-nfc-keychain' && score > 0) score += 6;

    return score;
  }

  function pinCustomFirst(products, catalog, customHandle) {
    var handle = customHandle || 'custom-nfc-keychain';
    var custom = null;
    var rest = [];

    products.forEach(function (product) {
      if (product.handle === handle) custom = product;
      else rest.push(product);
    });

    if (!custom) {
      custom = catalog.filter(function (product) {
        return product.handle === handle;
      })[0] || null;
    }

    return custom ? [custom].concat(rest) : rest;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function cardHtml(product, saleLabel, moneyFormat) {
    var onSale = product.compareAt > product.price && product.price > 0;
    var badge = onSale
      ? '<span class="kf-card__badge">' + escapeHtml(saleLabel) + '</span>'
      : '';
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy" width="720" height="720">'
      : '';
    var compare = onSale
      ? '<span class="kf-card__compare">' + escapeHtml(formatMoney(product.compareAt, moneyFormat)) + '</span>'
      : '';

    return (
      '<a class="kf-card" href="' + escapeHtml(product.url) + '" role="listitem">' +
        '<div class="kf-card__media">' + image + badge + '</div>' +
        '<div class="kf-card__body">' +
          '<h3 class="kf-card__title">' + escapeHtml(product.title) + '</h3>' +
          '<div class="kf-card__price">' +
            '<span>' + escapeHtml(formatMoney(product.price, moneyFormat)) + '</span>' +
            compare +
          '</div>' +
        '</div>' +
      '</a>'
    );
  }

  function gridSections() {
    return Array.prototype.slice.call(document.querySelectorAll('#ProductGridContainer')).map(function (node) {
      return node.closest('.shopify-section') || node;
    });
  }

  function syncGridVisibility() {
    var anyActive = finders.some(function (finder) {
      return finder.isActive();
    });
    document.documentElement.classList.toggle('keychain-finder-has-query', anyActive);
    gridSections().forEach(function (section) {
      section.classList.toggle('keychain-finder-grid-hidden', anyActive);
    });
  }

  function Finder(root) {
    this.root = root;
    this.input = root.querySelector('[data-kf-input]');
    this.form = root.querySelector('[data-kf-form]');
    this.clearButton = root.querySelector('[data-kf-clear]');
    this.count = root.querySelector('[data-kf-count]');
    this.status = root.querySelector('[data-kf-status]');
    this.panel = root.querySelector('[data-kf-panel]');
    this.results = root.querySelector('[data-kf-results]');
    this.empty = root.querySelector('[data-kf-empty]');
    this.emptyCopy = root.querySelector('[data-kf-empty-copy]');
    this.fallback = root.querySelector('[data-kf-fallback]');
    this.chips = Array.prototype.slice.call(root.querySelectorAll('[data-kf-chip]'));
    this.showAll = root.querySelector('[data-kf-show-all]');
    this.moreButton = root.querySelector('[data-kf-more]');
    this.moreLabelNode = root.querySelector('[data-kf-more-label]');
    this.trades = root.querySelector('[data-kf-trades]');
    this.tradesToggle = root.querySelector('[data-kf-trades-toggle]');
    this.tradesToggleLabel = root.querySelector('[data-kf-trades-toggle-label]');
    this.moreLabel = root.getAttribute('data-more-label') || 'More trades';
    this.lessLabel = root.getAttribute('data-less-label') || 'Show less';
    this.chipsExpanded = false;
    this.products = readSeed(root);
    this.moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
    this.saleLabel = root.getAttribute('data-sale-label') || 'Sale';
    this.noResults = root.getAttribute('data-no-results') || '';
    this.matchOne = root.getAttribute('data-match-one') || '1 match';
    this.matchMany = root.getAttribute('data-match-many') || '{{count}} matches';
    this.customHandle = root.getAttribute('data-custom-handle') || 'custom-nfc-keychain';
    this.hideGrid = root.getAttribute('data-hide-grid') !== 'false';
    this.timer = null;

    this.bind();
    this.setCount(this.products.length);
    this.hydrate();
  }

  Finder.prototype.bind = function () {
    var self = this;

    this.form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    this.input.addEventListener('input', function () {
      self.schedule();
    });

    this.input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        self.setQuery('');
        self.input.blur();
      }
    });

    this.clearButton.addEventListener('click', function () {
      self.setQuery('');
      self.input.focus();
    });

    if (this.showAll) {
      this.showAll.addEventListener('click', function () {
        self.setQuery('');
      });
    }

    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var query = chip.getAttribute('data-query') || '';
        var next = normalize(self.input.value) === normalize(query) ? '' : query;
        self.setQuery(next);
      });
    });

    if (this.moreButton) {
      this.moreButton.addEventListener('click', function () {
        self.chipsExpanded = !self.chipsExpanded;
        self.layoutChips();
      });
    }

    if (this.tradesToggle && this.trades) {
      this.tradesToggle.addEventListener('click', function () {
        self.setTradesOpen(self.trades.hidden);
      });
    }

    window.addEventListener('resize', function () {
      self.layoutChips();
    });
  };

  Finder.prototype.hydrate = function () {
    var self = this;
    fetchCatalog(this.root.getAttribute('data-products-url')).then(function (products) {
      if (products.length) {
        self.products = mergeCatalog(self.products, products);
      }
      self.render();
    });
  };

  Finder.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      self.render();
    }, 80);
  };

  Finder.prototype.setQuery = function (value) {
    this.input.value = value;
    this.render();
  };

  Finder.prototype.setTradesOpen = function (open) {
    if (!this.trades || !this.tradesToggle) return;
    this.trades.hidden = !open;
    this.tradesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (this.tradesToggleLabel) {
      this.tradesToggleLabel.textContent = open
        ? this.tradesToggle.getAttribute('data-hide-label') || 'Hide trades'
        : this.tradesToggle.getAttribute('data-show-label') || 'Browse trades';
    }
    if (open) this.scheduleChipLayout();
  };

  Finder.prototype.scheduleChipLayout = function () {
    var self = this;
    requestAnimationFrame(function () {
      self.layoutChips();
    });
  };

  Finder.prototype.layoutChips = function () {
    if (!this.moreButton) return;

    this.chips.forEach(function (chip) {
      chip.hidden = false;
    });

    if (this.chipsExpanded) {
      this.moreButton.hidden = false;
      this.moreButton.setAttribute('aria-expanded', 'true');
      if (this.moreLabelNode) this.moreLabelNode.textContent = this.lessLabel;
      return;
    }

    var tops = [];
    this.chips.forEach(function (chip) {
      var top = chip.offsetTop;
      if (tops.indexOf(top) === -1) tops.push(top);
    });
    tops.sort(function (a, b) {
      return a - b;
    });

    if (tops.length <= 2) {
      this.moreButton.hidden = true;
      return;
    }

    var cutoff = tops[1];
    var queryNorm = normalize(this.input.value);
    var hiddenPressed = false;

    this.chips.forEach(function (chip) {
      var overflow = chip.offsetTop > cutoff;
      var pressed = Boolean(queryNorm) && normalize(chip.getAttribute('data-query')) === queryNorm;
      if (overflow && pressed) hiddenPressed = true;
      chip.hidden = overflow;
    });

    if (hiddenPressed) {
      this.chipsExpanded = true;
      this.layoutChips();
      return;
    }

    this.moreButton.hidden = false;
    this.moreButton.setAttribute('aria-expanded', 'false');
    if (this.moreLabelNode) this.moreLabelNode.textContent = this.moreLabel;
  };

  Finder.prototype.isActive = function () {
    return this.hideGrid && this.products.length > 0;
  };

  Finder.prototype.paintResults = function (products) {
    this.empty.hidden = true;
    this.fallback.innerHTML = '';
    this.panel.hidden = false;
    this.results.innerHTML = products.map(function (product) {
      return cardHtml(product, this.saleLabel, this.moneyFormat);
    }, this).join('');
    this.setCount(products.length);
  };

  Finder.prototype.setCount = function (total) {
    var label = total === 1
      ? this.matchOne
      : this.matchMany.replace('{{count}}', String(total));
    this.count.hidden = false;
    this.count.textContent = label;
    this.status.textContent = label;
  };

  Finder.prototype.render = function () {
    var query = this.input.value;
    var queryNorm = normalize(query);
    var expanded = expandQuery(query);

    this.root.classList.toggle('is-active', Boolean(queryNorm));
    this.clearButton.hidden = !queryNorm;
    this.chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', normalize(chip.getAttribute('data-query')) === queryNorm ? 'true' : 'false');
    });
    if (this.showAll) {
      this.showAll.setAttribute('aria-pressed', queryNorm ? 'false' : 'true');
    }

    this.scheduleChipLayout();

    if (!queryNorm) {
      this.paintResults(this.products);
      syncGridVisibility();
      return;
    }

    if (expanded.leftover) {
      var tagged = chipTaggedHandles(this.chips);
      tagged[this.customHandle] = true;
      var leftovers = this.products.filter(function (product) {
        return !tagged[product.handle];
      });
      this.paintResults(pinCustomFirst(leftovers, this.products, this.customHandle));
      syncGridVisibility();
      return;
    }

    var ranked = this.products
      .map(function (product) {
        return { product: product, score: scoreProduct(product, query, expanded) };
      })
      .filter(function (row) {
        if (row.score < 18) return false;
        if (expanded.exclusive.length && expanded.exclusive.indexOf(row.product.handle) === -1) {
          return false;
        }
        return true;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .map(function (row) {
        return row.product;
      });

    this.panel.hidden = false;

    if (!ranked.length && queryNorm.length < 3) {
      this.paintResults(this.products);
      syncGridVisibility();
      return;
    }

    if (!ranked.length) {
      this.results.innerHTML = '';
      this.empty.hidden = false;
      this.emptyCopy.textContent = this.noResults;
      var custom = this.products.filter(function (product) {
        return product.handle === this.customHandle;
      }, this)[0];
      this.fallback.innerHTML = custom ? cardHtml(custom, this.saleLabel, this.moneyFormat) : '';
      this.setCount(0);
      this.status.textContent = this.noResults;
      syncGridVisibility();
      return;
    }

    this.paintResults(pinCustomFirst(ranked, this.products, this.customHandle));
    syncGridVisibility();
  };

  function initRoot(root) {
    if (!root || root.dataset.kfReady === 'true') return;
    root.dataset.kfReady = 'true';
    finders.push(new Finder(root));
  }

  function init() {
    document.querySelectorAll('[data-keychain-finder]').forEach(initRoot);
  }

  function unload(event) {
    var section = event.target;
    finders = finders.filter(function (finder) {
      return section.contains(finder.root) === false;
    });
    syncGridVisibility();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', unload);
  init();
})();
